import { render } from "./LoginFormAuth.vue?vue&type=template&id=12a77146&scoped=true"
import script from "./LoginFormAuth.vue?vue&type=script&lang=js"
export * from "./LoginFormAuth.vue?vue&type=script&lang=js"

import "./LoginFormAuth.vue?vue&type=style&index=0&id=12a77146&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a77146"]])

export default __exports__